module.exports = __webpack_public_path__ + "img/report-8.03bf12b0.jpg";